import { useHistory } from 'react-router-dom';
import { Button } from '../../../ui/core';
import { pillButtonSx } from '../../../ui/styles';
import { useHasPermission } from '../../../helpers/api/auth/index';

/**
 * The only entry point to the station builder at `/stations/map`.
 *
 * Gated on `station_mgmt`, deliberately the same permission as `AddStation`:
 * the builder's batch create writes stations, so anyone who cannot add one by
 * hand must not reach the bulk path either. Route-level access is not enough on
 * its own — `PrivateRoute` only checks that the user is signed in.
 */
const StationBuilderLink = () => {
  const history = useHistory();
  const hasManageStationPermission = useHasPermission('station_mgmt');

  if (!hasManageStationPermission) {
    return <></>;
  }

  return (
    <Button onClick={() => history.push('/stations/map')} sx={pillButtonSx}>
      Find stations on map
    </Button>
  );
};

export default StationBuilderLink;
